import React, { Component } from 'react';
import PropTypes          from 'prop-types';
import {
  AnimatedView,
  StatsTable,
  MaterialList,
  StatsGraph
}                         from '../../../components';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../services/fetchTools';

var Spinner = require('react-spinkit');

class LeadsSummary extends Component{
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func
    })
  };
  constructor(props){
    super(props);
    this.state = {
      venue: props.statsTable.revenue_per_month.requested_venue_id,
      active_cust_count:0,
      lead_data:[],
      lead_headers:[],
      loading:false,
  	}
  }

  componentDidMount() {
    this.locationChanged();
  }

  locationChanged() {
    this.setState({venue:this.props.statsTable.revenue_per_month.requested_venue_id,loading:false}, () => {
      this.getLeadsSummary()    
    })
  }

  getLeadsSummary(){
    const url = `${getLocationOrigin()}/eagleeye/getTableData/?report_id=7644&venue_id=${this.state.venue}`;
    const options = {...defaultOptions};

      return fetch(url, options)
         .then(checkStatus)
         .then(parseJSON)
         .then(data => {
              this.setState({lead_data:data.data,lead_headers:data.headers,loading:true})
         }).catch(error => error);
  }

  render(){
    var venue = this.state.venue;
    var headers = []
    if(this.state.lead_headers.length > 0){
      var tab_index = []
      for (var i = 0; i < this.state.lead_headers.length; i++) {
        if(this.state.lead_headers[i].indexOf("_hidden") == -1){
          headers.push(this.state.lead_headers[i]);
          tab_index.push(i);
        }
      }
    }

    

    console.log("STATE",this.state)
    if(this.state.venue != this.props.statsTable.revenue_per_month.requested_venue_id){
      this.locationChanged()
    }

    //var header = ['Day','Leads Added','Hot Leads','Leads Processed','Renewed Customers','Demos','Tickets']
    return(
    	<div>
    	<div style = {{justifyContent:'center',backgroundColor:'white',boxShadow: '0px 0px 20px 0px rgba(0, 0, 0, 0.10)',padding:'12px',borderRadius:'12px',marginBottom:'2%'}}>
		    
             <div style = {{display:'flex',justifyContent:'center',alignItems:'center',fontWeight:'900'}}> Leads Summary </div>
            
        </div>


        {this.state.loading ?
        	<div className="table-responsive" style={{borderRadius:'15px'}}>
            	<table className="table table-hover" style ={{width:'100%',borderRadius:'15px',boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.20)'}}>
            		<tr >
            			{
            				headers.map(item=>(
            				<th style={{textAlign:'center',height:'40px',backgroundColor:'#115691',color:'white',width:'14%'}}> {item} </th>
            				))
            			}
            		</tr>
                <tbody>
            		{ this.state.lead_data && this.state.lead_data.length > 0 ?
                  this.state.lead_data.map((data)=>(
                    <tr style={{backgroundColor:'white'}}>
                      { data.map((each,key)=>
                        tab_index.includes(key) &&
                        <td style={{textAlign:'center'}} dangerouslySetInnerHTML={{__html:each}}></td>
                        )
                      }
                    </tr>
                  ))
                :
                  <tr></tr>}
                </tbody>
            	</table>

          </div>
          :
          <div style={{height:500}}>
            <div style={{  position: 'absolute',top: '50%',left: '50%',width: '50%',height: '100%'}}> <Spinner size="50" name="ball-spin-fade-loader" color="#115691" /></div>
          </div>
          }
            
        </div>



    	)
  }    
}
export default LeadsSummary;


// WEBPACK FOOTER //
// ./src/app/views/centerportal/leadsSummary/LeadsSummary.js